import React from "react";
import { Navigate } from "react-router-dom";
import NewDirectOrder from "./NewDirectOrder";
import { useAuth } from "../AuthProvider";
import {
  canAccessNewDirectOrder,
  getDefaultHomePath,
} from "../Utils/accessControl";

const NewDirectOrderRoute = () => {
  const { user, isReady } = useAuth();

  if (!isReady) {
    return null;
  }

  if (!canAccessNewDirectOrder(user)) {
    return <Navigate to={getDefaultHomePath(user)} replace />;
  }

  return <NewDirectOrder />;
};

export default NewDirectOrderRoute;
